/** `EDIT_ORGANIZATION_PROFILE` → `Edit organization profile`. */
export const formatPermissionName = (name: string): string => {
    const words = name.trim().toLowerCase().split('_').filter(Boolean).join(' ');
    return words.charAt(0).toUpperCase() + words.slice(1);
};
